// extracted by mini-css-extract-plugin
export default {"hideTooltip":"u--z","fadeIn":"v--z","delay":"w--z","recommendedSizeTooltip":"x--z"};